
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AuthenticationContext } from "vue-adal";
import axios from "axios";
import JsonCSV from "vue-json-csv";
import { default as parse } from "csv-parse/lib/es5/sync";

@Component({
  components: { downloadCsv: JsonCSV },
})
export default class Acl extends Vue {
  public isBusy = false;
  public selected = [];
  public selectedRule: any = {
    UserMatch: "",
    ID: "",
    Privileges: {},
  };
  public selectedUnchangedUser: any = {};
  public filter: string = "";
  public csvText: string = "";
  public importError: string = "";
  public isRegex = false;
  // public lockTestUser = false;
  public roles = ["Admin", "Analyst", "ReadOnly"];
  public fields = [
    {
      key: "UserMatch",
      label: "Name",
      sortable: true,
    },
  ];
  public totalRows = 1;
  public currentPage = 1;
  public perPage = 10;
  public pageOptions = [5, 10, 15];
  public users: any[] = [];
  public exportUsers: any[] = [];
  public importUsers: any[] = [];
  public bulkBox;
  public exportAllUsers = false;

  public selectedPrivileges: any = {};
  public selectedRole: string = "Custom";
  public availableRoles: any = [
    "Basic",
    "Content Creator",
    "Administrator",
    "Custom",
  ];
  public testPrivileges: any = {};
  public testUserMatch: string = "";
  public matchedRules: any[] = [];
  public sampleUserList = [
    "joe@ey.com",
    "fred@gds.ey.com",
    "jean@sophists.com",
    "john@parthenon.sophists.com",
    "jane@ey-innovalue.de",
    "chris@parthenon.sophists.com",
    "jack@ey.com.us",
  ];

  public matchedTestResult: string[] = [];
  public unMatchedTestResult: string[] = [];

  @Watch("csvText")
  public csvChanged(val: number, oldVal: number) {
    this.importError = "";
    this.parseCsv();
  }

  private mkRolePrivs_(role: string) {
    let result: any = this.processPrivileges({});
    if (
      role === "Basic" ||
      role === "Content Creator" ||
      role === "Administrator"
    ) {
      result.Content.Read = true;
      result.Images.Read = true;
      result.Installers.Read = true;
      result.IssueLogs.Write = true;
      result.Projects.Read = true;
      result.Projects.Write = true;
      result.ServerConfiguration.Read = true;
      result.ServerDocumentation.Read = true;
      result.Slides.Read = true;
      result.Slides.Write = true;
      result.UserEventLog.Write = true;
      result.UserAuthConfiguration.ReadSelf = true;
    }
    if (role === "Content Creator") {
      result.Content.Write = true;
      result.Projects.EditSharedProjects = true;
      result.Images.Write = true;
    }
    if (role === "Administrator") {
      result.EMailIssues.Read = true;
      result.EMailIssues.Write = true;
      result.Installers.Write = true;
      result.IssueLogs.Read = true;
      result.ServerConfiguration.Write = true;
      result.UserAuthConfiguration.Read = true;
      result.UserAuthConfiguration.Write = true;
      result.UserEventLog.Read = true;
    }
    return result;
  }

  @Watch("selectedRole")
  public selectedRoleChanged(val: string, oldVal: string) {
    if (val !== "Custom") {
      // for anything BUT Custom, reset to exactly what is specified for that role
      this.selectedPrivileges = this.mkRolePrivs_(val);
    }
  }

  // cannot use watch because we dont want triggered when role change sets it, because then we would never be able to goto custom mode whith the previs of a special role
  public onChangeSelectedPrivilegesByUserAction()
  {
    if (JSON.stringify(this.selectedPrivileges) === JSON.stringify (this.mkRolePrivs_ ("Basic"))) {
      this.selectedRole = "Basic";
    }
    else if (JSON.stringify(this.selectedPrivileges) === JSON.stringify (this.mkRolePrivs_ ("Content Creator"))) {
      this.selectedRole = "Content Creator";
    }
    else if (JSON.stringify(this.selectedPrivileges) === JSON.stringify (this.mkRolePrivs_ ("Administrator"))) {
      this.selectedRole = "Administrator";
    }
    else {
      this.selectedRole = "Custom";
    }
  }

  @Watch("exportAllUsers")
  public exportAllUsersChanged(val: number, oldVal: number) {
    this.displayingModal();
  }

  public get errorMessage() {
    let error = "";
    const u = this.selectedRule;
    if (u.UserMatch === "") {
      error = "User Match cannot be empty";
    } else if (u.UserMatch.startsWith("/") && !this.isRegex) {
      error = "Only a Regular Expression can start with /";
    } else if (this.isRegex && !u.UserMatch.startsWith("/")) {
      error = "A Regular Expression should start with /";
    }
    return error;
  }
  public mounted() {
    this.loadRules();
    document
      .querySelectorAll(".tableFixHead")
      .forEach((el) => el.addEventListener("scroll", this.tableFixHead));
  }

  public displayingModal() {
    this.exportUsers = this.users.filter((d) => {
      return this.exportAllUsers || !d.ProvisionedInConfigurationFile;
    });
  }

  public tableFixHead(e) {
    const el = e.target;
    const sT = el.scrollTop;
    el.querySelectorAll("thead th").forEach(
      (th) => (th.style.transform = `translateY(${sT}px)`)
    );
  }
  public newRule() {
    this.setEmptyRule();
    this.isRegex = false;
    this.selectedRule.ID = "-NEW-";
    this.selectedRule.ProvisionedInConfigurationFile = false;
    this.selectedPrivileges = this.processPrivileges(
      this.selectedRule.Privileges
    );
    this.onChangeSelectedPrivilegesByUserAction();
  }

  public mungePrivilegeName(priv) {
    if (priv == "EditSharedProjects") {
      return "Edit-Shared";
    }
    if (priv == "EditAnyProject") {
      return "Edit-Any";
    }
    if (priv == "ReadSelf") {
      return "Read-Self";
    }
    return priv;
  }

  public setEmptyRule() {
    this.selectedRule.UserMatch = "";
    this.selectedRule.Privileges = this.getEmptyPrivileges();
    this.selectedRule.ID = "";

    return true;
  }

  public loadRules() {
    this.isBusy = true;

    axios.get("/api/v4/UserAuth/Rules").then(
      (response) => {
        this.processUsers(response.data);
        this.runTests();
        this.isBusy = false;
      },
      (error) => {}
    );
  }

  public getEmptyPrivileges() {
    return {
      Content: [],
      EMailIssues: [],
      Images: [],
      Installers: [],
      IssueLogs: [],
      Projects: [],
      ServerConfiguration: [],
      ServerDocumentation: [],
      Slides: [],
      UserAuthConfiguration: [],
      UserEventLog: [],
    };
  }

  public getPrivilegeDocs() {
    return {
      Content:
        "The Content API is used for a wide variety of things such as Spelling Dictionaries, Bullet imsages, etc...",
      EMailIssues:
        "This is used to configure who is notified of reported issues.",
      Images:
        "Read: Mandatory for all users to import logos etc.\n\nWrite: Necessary for graphics designers to upload logos etc.",
      Installers:
        "This is used to control uploading/downloading new Slidefox installers.",
      IssueLogs:
        "Read: Only important for helpdesk, ticked box sends a copy of each reported issue via mail.\n\nWrite: Mandatory for all users, allows to send a ticket via mail icon in group.",
      Projects:
        "Read / write: Mandatory for all users to enable creating own projects\n\nEdit shared: Mandatory for graphics designers to edit / add shared libraries.\n\nEdit any: Allows to overwrite and delete literally everything and gives access to projects, even if they are not shared with one another",
      ServerConfiguration:
        "This is not used directly by SlideFox.\n\nBut there are some server configurations that can be set from calls (a POST to /Configuration). The most common I know of is by automated testing, to turn on/off test mode.",
      ServerDocumentation:
        "Read: allow you to see online documentation if you go to the server’s webpage (and this restriction is important to IT because they don’t want 3rd parties privy to details of server API calls\n\nWrite: never used.",
      Slides:
        "Used in conjunction with Project privileges, to access slide library (privileges anded).",
      UserAuthConfiguration:
        "This is the set of abilities for each user (what is being set here!) SlideFox only uses “Read-Self” which lets the addin find out what the user should be allowed to do (for example, whether they can add slide library slides to the “public” section.",
      UserEventLog:
        "Reverse ssense of what you might guess: normal users write to the log (their activities) and Read allows viewing reports of what users have done.",
    };
  }
  private getPrivilegeDoc(p) {
    return this.getPrivilegeDocs()[p];
  }

  public runTests() {
    const test = this.testUserMatch.trim();
    const mergedPrivileges = {};
    if (test === "") {
      return;
    }
    this.testPrivileges = {};
    this.matchedRules = [];

    this.users.map((r) => {
      try {
        const regExp = this.getRegExp(r.UserMatch);

        const result = test.match(regExp);
        if (result && result.length > 0) {
          this.matchedRules.push(r.UserMatch);
        }
      } catch (e) {
        console.error(e);
      }
    });

    axios.get(`/api/v4/UserAuth/Users/${test}`).then(
      (response: any) => {
        this.testPrivileges = this.processPrivileges(response.data.Privileges);
        this.isBusy = false;
      },
      (error) => {}
    );

    // this.testPrivileges = this.processPrivileges(mergedPrivileges);
  }

  public getRegExp(s) {
    const r = /\/(.*)\/(.*)/;
    const result = s.match(r);

    if (result === null || result.length < 3) {
      return new RegExp(s, "i");
    } else {
      return new RegExp(result[1], result[2]);
    }
  }

  public displayEditBox() {
    if (this.selectedRule.ID === "") {
      return false;
    }

    return true;
  }

  public processImport() {
    this.importUsers.forEach((u) => {
      try {
        this.saveRule(u);
      } catch (e) {
        this.importError = "Some Users Were not Imported";
      }
    });
    this.makeToast("Bulk Import Finished!");
    this.csvText = "";
  }

  public getPrivileges() {
    const privileges = {};

    for (const p in this.selectedPrivileges) {
      if (!this.selectedPrivileges.hasOwnProperty(p)) {
        continue;
      }

      const k = Object.keys(this.selectedPrivileges[p]).filter((key) => {
        return this.selectedPrivileges[p][key];
      });
      privileges[p] = k;
    }

    return privileges;
  }

  public async saveRule(user = null) {
    this.isBusy = true;
    this.selectedRule.Privileges = this.getPrivileges();
    const u: any = {
      Privileges: this.selectedRule.Privileges,
      UserMatch: this.selectedRule.UserMatch,
    };
    let saveUrl = `/api/v4/UserAuth/Rules`;

    if (this.selectedRule.ID !== "-NEW-") {
      u.ID = this.selectedRule.ID;
      saveUrl = saveUrl + "/" + u.ID;
    }
    const isBulkSave = false;

    if (this.isRuleValid(u)) {
      await axios({
        method: this.selectedRule.ID === "-NEW-" ? "post" : "put",
        url: saveUrl,
        data: u,
      }).then(
        (response) => {
          this.isBusy = false;
          if (!isBulkSave) {
            this.makeToast("Rule Saved!");
            this.loadRules();
          }
        },
        (error) => {
          this.isBusy = false;
          this.makeToast(
            "Rule Could not be saved, please try again later.",
            "danger"
          );
        }
      );
    } else {
      this.importError = "Some Users Were not Imported";
    }
  }

  public isInputValid() {
    const u = this.selectedRule;
    if (u.UserMatch === "") {
      return false;
    }
    if (u.UserMatch.startsWith("/") && !this.isRegex) {
      return false;
    }

    if (this.isRegex && !u.UserMatch.startsWith("/")) {
      return false;
    }
    return true;
  }

  public isRuleValid(user = null) {
    let u = this.selectedRule;

    if (user) {
      u = user;
    }
    if (!u.UserMatch || u.UserMatch.trim() === "") {
      this.makeToast("Only a Regular Expression can start with '/'", "danger");
      return false;
    }

    if (u.UserMatch.startsWith("/") && !this.isRegex) {
      this.makeToast("A Regular Expression should start with '/'", "danger");
      return false;
    }

    if (this.isRegex && !u.UserMatch.startsWith("/")) {
      return false;
    }

    return true;
  }
  public deleteUser(userName = "", notify = true) {
    this.isBusy = true;
    const u = this.selectedRule.ID;

    axios.delete(`/api/v4/UserAuth/Rules/${u}`).then(
      (response) => {
        this.isBusy = false;
        if (notify) {
          this.makeToast("Rule Deleted!");
        }
        this.cancel();
        this.loadRules();
      },
      (error) => {
        this.isBusy = false;
        this.makeToast(
          "Rule Could not be deleted, please try again later.",
          "danger"
        );
      }
    );
  }

  public makeToast(msg, vrant = "success") {
    this.$bvToast.toast(`${msg}`, {
      title: "Operation Completed",
      autoHideDelay: 3000,
      variant: vrant,
      appendToast: false,
    });
  }

  public cancel() {
    this.setEmptyRule();
    (this.$refs.rulesTable as any).clearSelected();
  }
  public processUsers(d) {
    // this.users.splice(0, this.users.length);
    this.users = d;

    this.totalRows = this.users.length;
  }

  public rowSelected(items) {
    if (items.length > 0) {
      const u = items[0];
      this.selectedRule = u;
      this.selectedPrivileges = this.processPrivileges(u.Privileges);
      this.isRegex = u.UserMatch.startsWith("/");
      this.onChangeSelectedPrivilegesByUserAction();

      this.sampleTest();

      if (this.isRegex) {
        this.testUserMatch = this.matchedTestResult[0] || "";
        this.runTests();
      } else {
        this.testUserMatch = u.UserMatch;
        this.runTests();
      }
    }
  }

  public sampleTest() {
    this.matchedTestResult = [];
    this.unMatchedTestResult = [];

    if (!this.isRegex) {
      return;
    }

    const r = this.getRegExp(this.selectedRule.UserMatch);

    this.sampleUserList.forEach((u: string) => {
      if (r.test(u) && this.matchedTestResult.length < 2) {
        this.matchedTestResult.push(u);
      } else if (this.unMatchedTestResult.length < 2) {
        this.unMatchedTestResult.push(u);
      }
    });
  }

  public rowClass(item, type) {
    if (!item) {
      return;
    }
    if (item.ProvisionedInConfigurationFile === true) {
      return "row-disabled";
    }
  }

  public processPrivileges(privileges) {
    const list = this.getEmptyPrivileges();

    if (privileges === null) {
      return null;
    }

    for (const p in list) {
      const priv = privileges[p] || "";

      const o: any = {
        Read: priv.includes("Read"),
        Write: priv.includes("Write"),
      };

      if (p === "Projects") {
        o.EditSharedProjects = priv.includes("EditSharedProjects");
        o.EditAnyProject = priv.includes("EditAnyProject");
      }

      if (p === "UserAuthConfiguration") {
        o.ReadSelf = priv.includes("ReadSelf");
      }

      // Vue.set(this.selectedPrivileges, p, o);
      list[p] = o;
    }
    return list;
  }

  public parseCsv() {
    try {
      const records = parse(this.csvText, {
        columns: true,
        skip_empty_lines: true,
      });
      this.importUsers = records;
      // this.validateImportUsers();
    } catch (e) {
      console.log(e);
      this.importError = e;
    }
  }
}
